import z from 'zod';

export const claimNumbersSchema = (maxCount: number) =>
  z.object({
    isoCountry: z.string({ required_error: 'required' }).trim().min(1, { message: 'required' }),
    capabilities: z.any(),
    matchTo: z.any(),
    numbers: z
      .array(
        z.object({
          phoneNumber: z.string().trim().min(1, { message: 'Choose a number to claim' }),
          friendlyName: z.string().trim().min(1, { message: 'Enter a friendly name' }),
        })
      )
      .min(1, { message: 'Choose at least one number to claim' })
      .max(maxCount, {
        message: `You can claim at most ${maxCount} number${maxCount === 1 ? '' : 's'}`,
      }),
  });

export type ClaimNumbersSchema = z.infer<ReturnType<typeof claimNumbersSchema>>;
